import React, { useEffect, useState } from 'react';
import { RaisedButton, TextField } from 'material-ui';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import Comment from './Comment';
import { getIssue, addIssueComment, deleteIssueComment, updateIssueComment } from 'actions/issues';

/**
 * 
 * @param {{
 *  comments: Comment[],
 * }} param0 
 * @returns 
 */
function Comments({ issue, addIssueComment, deleteIssueComment, updateIssueComment, user }) {
    const [comments, setComments] = useState(issue.comments || []);
    const [newComment, setNewComment] = useState('');
    const [commentInEditMode, setCommentInEditMode] = useState(null);
    
    useEffect(() => {
      setComments(issue.comments);
    }, [issue.comments]);

    const addComment = () => {
        if (!newComment) return;
        addIssueComment(issue._id, { text: newComment });
        setNewComment('');
    };

    const deleteComment = commentId => {
        deleteIssueComment(issue._id, commentId);
    };

    const handleCommentInput = (value) => {
        setNewComment(value);
    }

    /**
     * @param {Comment} comment 
     */
    const toggleEditMode = (comment) => {
        setCommentInEditMode(comment);
        setNewComment(comment.text);
    }

    const cancelEditMode = () => {
        setCommentInEditMode(null);
        setNewComment('');
    };

    const handleEditComment = () => {
        updateIssueComment(issue._id, commentInEditMode._id, { text: newComment });
        setCommentInEditMode(null);
        setNewComment('');
    };

    return (
        <div
            className='comments'
        >
            <div className='form'>
                <div id='input'>
                    <TextField 
                        hintText='Comment'
                        value={newComment}
                        fullWidth
                        multiLine
                        underlineShow={false}
                        rows={2}
                        onChange={(e) => handleCommentInput(e.target.value)}
                        style={{ height: '56px', fontSize: '13px', lineHeight: '19.5px'}}
                        hintStyle={{ marginTop: 'unset', bottom: 'unset', fontSize: '13px' }}
                        textareaStyle={{ marginTop: 'unset', marginBottom: 'unset', height: '56px' }}
                    />
                </div>
                <div id='button'>
                    {
                        commentInEditMode ? 
                        <React.Fragment>
                            <RaisedButton
                                label='Edit'
                                onClick={handleEditComment}
                                primary
                                disabled={!newComment}
                            />
                            <RaisedButton
                                className='cancel'
                                label='Cancel' 
                                buttonStyle={{ backgroundColor: '#FFFAF0' }}
                                onClick={cancelEditMode}
                                primary
                            />
                        </React.Fragment> 
                        :
                        <RaisedButton
                            label='Send'
                            onClick={addComment}
                            primary
                            disabled={!newComment}
                        />
                    }
                </div>
            </div>
            <div className='list'>
                {
                    comments.map(comment => {
                        return (
                            <Comment 
                                key={comment._id}
                                comment={comment}
                                deleteComment={deleteComment}
                                isInEditMode={(commentInEditMode || {})._id === comment._id}
                                toggleEditMode={toggleEditMode}
                                canEditOrDelete={user._id === comment.addedBy._id }
                            />
                        )
                    })
                }
            </div>
        </div>  
    );
}

export default connect(
    ({ issue, user: { user } }) => {
        return {
            isLoaded: issue && issue.isLoaded,
            issue: { ...issue, comments: issue.comments || [] },
            comments: issue.comments || [],
            user: _.pick(user, ['_id', 'email']),
        };
    },
    (dispatch) =>
        bindActionCreators(
            {
                getIssue, 
                addIssueComment,
                deleteIssueComment,
                updateIssueComment,
            },
        dispatch
      )
)(Comments);

/**
 * @typedef {Object} Comment
 * @property {string} _id
 * @property {string} text
 * @property {Date} addedAt
 * @property {AddedBy} addedBy
 */

/**
 * @typedef {Object} AddedBy
 * @property {string} _id
 * @property {string} email
 */



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/comments/Comments.jsx